webpackJsonp([25],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(75);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var domainMap = {"perm":{"default":"//api-perm.1sapp.com/"},"tagging":{"default":"//biaozhu.qutoutiao.net/"},"crowd":{"default":"//prd-tag-qa.qutoutiao.net/"},"search":{"default":"//api.1sapp.com/"}}; // eslint-disable-line
var codeEvn = "production"; // eslint-disable-line
var projectName = "tagging"; // eslint-disable-line
var projectTitle = "内容标注后台"; // eslint-disable-line
var isProduction = codeEvn === 'production' || codeEvn === 'preview';

var branchMap = {};

var ApiDomain = function () {
    function ApiDomain() {
        _classCallCheck(this, ApiDomain);

        this.domains = this.getDomains();
    }

    _createClass(ApiDomain, [{
        key: 'getDomains',
        value: function getDomains() {
            var map = {};
            for (var i in domainMap) {
                var key = i + '_branch';
                var branch = _jsCookie2.default.get(key) || 'default';
                branchMap[i] = branch;
                map[i] = this.getBranch(i, branch);
            }
            return map;
        }
    }, {
        key: 'getBranch',
        value: function getBranch(type, branch) {
            var domain = domainMap[type];
            if (domain) {
                if (domain.hasOwnProperty(branch)) {
                    return domain[branch];
                } else {
                    console.error('\u4E0D\u5B58\u5728' + type + '\u5BF9\u5E94\u9879\u76EE' + branch + '\u5206\u652F');
                }
            } else {
                console.error('\u4E0D\u5B58\u5728' + type + '\u5BF9\u5E94\u9879\u76EE');
            }
        }
    }, {
        key: 'getUrl',
        value: function getUrl(api) {
            var domains = this.domains;
            var project = api.project,
                path = api.path;

            var domain = '';
            if (project in domains) {
                domain = domains[project];
            }
            if (!domain) {
                throw new Error('ApiDomain.getUrl\uFF1A\u6CA1\u6709\u914D\u7F6E\u8BE5 ' + project + ' \u9879\u76EE\u7684 domain');
            }
            if (/^\//.test(path)) {
                path = path.substring(1, path.length);
            } else {
                console.warn('路径需要以/开头！');
            }
            return '' + domain + path;
        }
    }, {
        key: 'getBranchMap',
        value: function getBranchMap() {
            return branchMap;
        }
    }, {
        key: 'isProduct',
        value: function isProduct() {
            return isProduction;
        }
    }, {
        key: 'getEvn',
        value: function getEvn() {
            return codeEvn;
        }
    }, {
        key: 'isDevelopment',
        value: function isDevelopment() {
            return !isProduction;
        }
    }, {
        key: 'getProject',
        value: function getProject() {
            return projectName;
        }
    }, {
        key: 'getProjectTitle',
        value: function getProjectTitle() {
            return projectTitle;
        }
    }], [{
        key: 'setApiBranch',
        value: function setApiBranch(query) {
            if (isProduction) {
                // 线上代码不保存高度cookie
                return;
            }
            for (var i in domainMap) {
                var key = '_' + i;
                if (query.hasOwnProperty(key)) {
                    var branch = query[key];
                    if (domainMap[i].hasOwnProperty(branch)) {
                        branchMap[i] = branch;
                        _jsCookie2.default.set(i + '_branch', branch);
                    }
                }
            }
        }
    }]);

    return ApiDomain;
}();

exports.default = ApiDomain;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by maofaming on 2017/4/21.
 */

var Store = function () {
    function Store() {
        _classCallCheck(this, Store);

        this._store = {};
        this._isNativeStore = false;

        if (!window.localStorage) {
            this._isNativeStore = false;
            console.log('window.localStorage不可用，已转为内存存储！');
        } else {
            this._isNativeStore = true;
            this._store = window.localStorage;
        }
    }

    _createClass(Store, [{
        key: 'setItem',
        value: function setItem(key, value) {
            if (this._isNativeStore) {
                this._store.setItem(key, value);
            } else {
                this._store[key] = value;
            }
        }
    }, {
        key: 'getItem',
        value: function getItem(key) {
            if (this._isNativeStore) {
                return this._store.getItem(key);
            } else {
                return this._store[key];
            }
        }
    }]);

    return Store;
}();

var Debugger = function () {
    function Debugger() {
        _classCallCheck(this, Debugger);

        this._requestStore = [];
        this._store = null;
        this._maxCount = 300;

        this._store = new Store();
        this._requestStore = this.getRecord();
    }

    _createClass(Debugger, [{
        key: 'download',
        value: function download(name) {
            var _Debugger$getParamete = Debugger.getParameter(),
                cookie = _Debugger$getParamete.cookie,
                userAgent = _Debugger$getParamete.userAgent;

            var fileName = name + '_debug.json';
            var content = JSON.stringify({
                cookie: cookie,
                userAgent: userAgent,
                curl: this.getRecord()
            }, null, 4);
            var blob = new Blob([content]);
            var aLink = document.createElement('a');
            var url = URL.createObjectURL(blob);

            aLink.download = fileName;
            aLink.href = url;
            aLink.click();
            window.URL.revokeObjectURL(url);
        }
    }, {
        key: 'getRecord',
        value: function getRecord() {
            var requestStroage = this._store.getItem('requestStorage');
            if (requestStroage) {
                try {
                    return JSON.parse(requestStroage);
                } catch (err) {
                    console.log('本地调试数据恢复错误...');
                    this._store.setItem('requestStorage', '');
                    return [];
                }
            } else {
                return [];
            }
        }
    }, {
        key: 'updateRecord',
        value: function updateRecord() {
            try {
                this._store.setItem('requestStorage', JSON.stringify(this._requestStore, null, 2));
            } catch (err) {
                console.log('本地调试数据恢复错误...');
                this._store.setItem('requestStorage', '');
                return [];
            }
        }
    }, {
        key: 'save',
        value: function save(url, type, data) {
            var myDate = new Date();
            var curl = Debugger.createCURL(url, type, data);
            var requestStore = this._requestStore;
            var length = requestStore.length;
            if (length > this._maxCount) {
                requestStore.shift();
            }
            requestStore.push({
                time: myDate.toLocaleString(),
                curl: curl
            });
            this.updateRecord();
        }
    }], [{
        key: 'getParameter',
        value: function getParameter() {
            return {
                userAgent: navigator.userAgent,
                cookie: document.cookie,
                referrer: location.href,
                origin: document.origin
            };
        }
    }, {
        key: 'createCURL',
        value: function createCURL(url, type, data) {
            var _Debugger$getParamete2 = Debugger.getParameter(),
                referrer = _Debugger$getParamete2.referrer,
                origin = _Debugger$getParamete2.origin;

            return ['curl', "'" + url + (type === 'post' ? '' : '?' + data) + "'", "-H 'Pragma: no-cache'", "-H 'Origin: " + origin + "'", "-H 'Accept-Encoding: gzip, deflate, sdch'", "-H 'Accept-Language: zh-CN,zh;q=0.8,en;q=0.6,zh-TW;q=0.4'", "-H 'User-Agent: " + navigator.userAgent + "'", type === 'post' ? "-H 'Content-Type: application/x-www-form-urlencoded; charset=UTF-8' " : '', "-H 'Accept: application/json, text/plain, */*'", "-H 'Referer: " + referrer + "'", "-H 'Connection: keep-alive'", "-H 'Cache-Control: no-cache'", type === 'post' ? "--data '" + data + "'" : '', '--compressed'].join(' ');
        }
    }]);

    return Debugger;
}();

exports.default = new Debugger();

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mutations;

var _mutationTypes = __webpack_require__(55);

var types = _interopRequireWildcard(_mutationTypes);

var _lazyLoading = __webpack_require__(81);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _taskmanage = __webpack_require__(352);

var _taskmanage2 = _interopRequireDefault(_taskmanage);

var _contentlabel = __webpack_require__(350);

var _contentlabel2 = _interopRequireDefault(_contentlabel);

var _qualityManage = __webpack_require__(351);

var _qualityManage2 = _interopRequireDefault(_qualityManage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var localPerms = [];
try {
    localPerms = JSON.parse(localStorage.getItem('qu_local_perms')) || [];
} catch (err) {}

var items = [{
    name: 'auth',
    path: 'Login',
    meta: {
        icon: 'fa-tachometer',
        label: '登陆',
        nomenu: true
    },
    component: (0, _lazyLoading2.default)('auth/WxLogin')
}, _taskmanage2.default, _contentlabel2.default, _qualityManage2.default
// statistic
];

authNomenu(items, localPerms);

var state = {
    items: items
};

var mutations = (_mutations = {}, _defineProperty(_mutations, types.EXPAND_MENU, function (state, menuItem) {
    if (menuItem.index > -1) {
        if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
            state.items[menuItem.index].meta.expanded = menuItem.expanded;
        }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
        menuItem.item.meta.expanded = menuItem.expanded;
    }
}), _defineProperty(_mutations, types.TOGGLE_NO_MENU, function (state, _ref) {
    var menuItem = _ref.menuItem,
        nomenu = _ref.nomenu;

    menuItem.meta.nomenu = nomenu;
}), _mutations);

function authNomenu(menu) {
    var perms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    // menu: 菜单列表，perm：权限列表
    menu.forEach(function (menuItem) {
        var _menuItem$meta = menuItem.meta,
            meta = _menuItem$meta === undefined ? {} : _menuItem$meta;
        var _meta$auth = meta.auth,
            auth = _meta$auth === undefined ? {} : _meta$auth;


        if (!meta.nomenu && auth.needApis) {
            auth.needApis.forEach(function (api) {
                var no = true; // 默认不显示
                for (var i = 0, len = perms.length; i < len; i++) {
                    // 遍历权限列表
                    var p = perms[i];
                    if (p.project === api.project && p.uri === api.path) {
                        if (!p.has) {
                            // has不为1 时，不显示，结束遍历
                            no = true;
                            break;
                        } else {
                            // has为1时，显示
                            no = false;
                        }
                    }
                }
                menuItem.meta.nomenu = no;
            });
        }
        if (menuItem.children) {
            authNomenu(menuItem.children, perms);
        }
    });
    return menu;
}

exports.default = {
    state: state,
    mutations: mutations
};

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  "data-v-646ebffe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrl = exports.request = exports.Api = undefined;

var _axios = __webpack_require__(170);

var _axios2 = _interopRequireDefault(_axios);

var _Auth = __webpack_require__(76);

var _Auth2 = _interopRequireDefault(_Auth);

var _QuRequest = __webpack_require__(66);

var _QuRequest2 = _interopRequireDefault(_QuRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseRequest = new _QuRequest2.default(); /* eslint-disable */
// import apisConfig from '../../config/apiDomainConfig'


var apiDomains = {"perm":{"default":"//api-perm.1sapp.com/"},"tagging":{"default":"//biaozhu.qutoutiao.net/"},"crowd":{"default":"//prd-tag-qa.qutoutiao.net/"},"search":{"default":"//api.1sapp.com/"}};

var api = {
  tagging: apiDomains.tagging.default,
  // qutoutiao: apiDomains.qupost.default,
  perm: apiDomains.perm.default
  // audit:apiDomains.audit.default
};

_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

var Api = {
  update: function update(query) {
    if (query._qk && query._qk in apiDomains.qukan) {
      api.qukan = apiDomains.qukan[query._qk];
    }
    if (query._qtt && query._qtt in apiDomains.qutoutiao) {
      api.qutoutiao = apiDomains.qutoutiao[query._qtt];
    }
    if (query._audit && query._audit in apiDomains.audit) {
      api.audit = apiDomains.audit[query._audit];
    }
  }
};

function getProject(target) {
  var project = 'qukan';
  switch (target) {
    case 'qutoutiao':
      project = 'qupost';
      break;
    case 'perm':
      project = 'perm';
      break;
    case 'audit':
      project = 'audit';
      break;
  }
  return project;
}

function getUrl(path) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'qukan';

  return baseRequest.getUrl({
    project: getProject(target),
    path: path
  });
}

function request(reqData) {
  // console.log(reqData)
  var quRequest = new _QuRequest2.default();
  return quRequest.nativeSend({
    url: reqData.url,
    type: reqData.method,
    timeout: reqData.timeout,
    headers: reqData.headers
  }, reqData.data);
}

Api.install = function (Vue) {
  Vue.prototype.$httpFactory = function (oApi) {
    var reqs = {};

    var _loop = function _loop(key) {
      (function (api) {
        reqs[key] = function () {
          var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var quRequest = new _QuRequest2.default();
          return quRequest.send({
            project: getProject(api.target),
            path: api.path,
            type: api.type
          }, data);
        };
      })(oApi[key]);
    };

    for (var key in oApi) {
      _loop(key);
    }
    return reqs;
  };

  Vue.prototype.$getApiUrl = getUrl;

  Vue.prototype.$getApiEnvConfig = function () {
    return apisConfig;
  };

  Vue.prototype.$blockRequest = function (_ref) {
    var $elem = _ref.$elem,
        req = _ref.req,
        _ref$pendingText = _ref.pendingText,
        pendingText = _ref$pendingText === undefined ? '操作中' : _ref$pendingText;

    if (!$elem) {
      $elem = document.createElement('button');
    }
    if (!$elem || $elem._req_block) return;

    var isButton = $elem.nodeName.toLowerCase() === 'button';
    var oText = $elem.innerText;

    if (isButton) $elem.setAttribute('disabled', true);

    $elem.innerText = pendingText;
    $elem._req_block = true;

    return req.fin(function () {
      if (isButton) $elem.removeAttribute('disabled');
      $elem._req_block = false;
      $elem.innerText = oText;
    });
  };

  Vue.prototype.$getConfig = function (name) {
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var token = _Auth2.default.getToken();

    return request({
      url: getUrl('/admin/config/getConfigList'),
      method: 'get',
      data: {
        platform: platform,
        name: name,
        token: token
      },
      timeout: 5000
    }).then(function (res) {
      var data = res.data;
      if (data.length && data.length > 0) {
        data = data[0][platform];
        return data;
      } else {
        throw new Error('配置不存在');
      }
    });
  };

  Vue.prototype.$checkContentSimilar = function (_ref2) {
    var content = _ref2.content,
        _ref2$content_type = _ref2.content_type,
        content_type = _ref2$content_type === undefined ? 1 : _ref2$content_type,
        _ref2$check_type = _ref2.check_type,
        check_type = _ref2$check_type === undefined ? 0 : _ref2$check_type,
        _ref2$similar_thresho = _ref2.similar_threshold,
        similar_threshold = _ref2$similar_thresho === undefined ? 0.8 : _ref2$similar_thresho,
        _ref2$currentId = _ref2.currentId,
        currentId = _ref2$currentId === undefined ? '' : _ref2$currentId;

    var token = _Auth2.default.getToken();
    return request({
      url: getUrl('/admin/content/viewSimilarity'),
      method: 'post',
      data: {
        content: content,
        content_type: content_type,
        check_type: check_type,
        similar_threshold: similar_threshold,
        token: token
      },
      timeout: 10 * 1000
    }).then(function (_ref3) {
      var code = _ref3.code,
          data = _ref3.data,
          message = _ref3.message;

      var docIds = [];
      var docs = [];

      if (code != 0) {
        throw new Error('检查文章相似度失败： ' + message);
      }

      if (data.doc_url && data.doc_url.length) {
        data.doc_id.forEach(function (id, idx) {
          if (!currentId || id != currentId) {
            docIds.push(id);
            docs.push(data.doc_url[idx]);
          }
        });
      }
      return {
        docs: docs,
        docIds: docIds
      };
    });
  };
};

exports.Api = Api;
exports.request = request;
exports.getUrl = getUrl;

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MsgBoxOwn = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _MessageBoxOwn = __webpack_require__(638);

var _MessageBoxOwn2 = _interopRequireDefault(_MessageBoxOwn);

var _merge = __webpack_require__(178);

var _merge2 = _interopRequireDefault(_merge);

var _vdom = __webpack_require__(326);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    title: undefined,
    content: ''
};
var instance = void 0,
    currentMsg = void 0;
var msgQueue = [];
var MsgBoxOwnConstructor = _vue2.default.extend(_MessageBoxOwn2.default);

var defaultCallback = function defaultCallback(action) {
    // debugger;
    if (currentMsg) {
        var callback = currentMsg.callback;
        if (typeof callback === 'function') {
            if (instance.showInput) {
                callback(instance.inputValue, action);
            } else {
                callback(action);
            }
        }
        if (currentMsg.resolve) {
            if (action === 'sure') {
                if (instance.showInput) {
                    currentMsg.resolve({ value: instance.inputValue, action: action });
                } else {
                    currentMsg.resolve(action);
                }
            } else if (action === 'cancel' && currentMsg.reject) {
                currentMsg.reject(action);
            }
        }
    }
};

var initInstance = function initInstance() {
    // debugger;
    instance = new MsgBoxOwnConstructor({
        el: document.createElement('div')
    });
    instance.callback = defaultCallback;
};

var showNextMsg = function showNextMsg() {
    // debugger;
    if (!instance) {
        initInstance();
    }
    instance.action = '';

    if (!instance.visible || instance.closeTimer) {
        if (msgQueue.length > 0) {
            currentMsg = msgQueue.shift();

            var options = currentMsg.options;
            for (var prop in options) {
                if (options.hasOwnProperty(prop)) {
                    instance[prop] = options[prop];
                }
            }
            if (options.callback === undefined) {
                instance.callback = defaultCallback;
            }

            var oldCb = instance.callback;
            instance.callback = function (action, instance) {
                oldCb(action, instance);
                showNextMsg();
            };
            if ((0, _vdom.isVNode)(instance.message)) {
                instance.$slots.default = [instance.message];
                instance.message = null;
            } else {
                delete instance.$slots.default;
            }
            ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape'].forEach(function (prop) {
                if (instance[prop] === undefined) {
                    instance[prop] = true;
                }
            });
            document.body.appendChild(instance.$el);

            _vue2.default.nextTick(function () {
                instance.visible = true;
            });
        }
    }
};

var MsgBoxOwn = function MsgBoxOwn(options, callback) {
    // debugger;
    if (_vue2.default.prototype.$isServer) return;
    if (typeof options === 'string') {
        options = {
            message: options
        };
        if (arguments[1]) {
            options.title = arguments[1];
        }
        if (arguments[2]) {
            options.type = arguments[2];
        }
    } else if (options.callback && !callback) {
        callback = options.callback;
    }

    if (typeof Promise !== 'undefined') {
        return new Promise(function (resolve, reject) {
            // eslint-disable-line
            msgQueue.push({
                options: (0, _merge2.default)({}, defaults, MsgBoxOwn.defaults, options),
                callback: callback,
                resolve: resolve,
                reject: reject
            });

            showNextMsg();
        });
    } else {
        msgQueue.push({
            options: (0, _merge2.default)({}, defaults, MsgBoxOwn.defaults, options),
            callback: callback
        });

        showNextMsg();
    }
};

MsgBoxOwn.setDefaults = function (defaults) {
    MsgBoxOwn.defaults = defaults;
};

MsgBoxOwn.qttConfirmShortCut = function (message, title, options) {
    //   debugger;
    if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
        options = title;
        title = '';
    } else if (title === undefined) {
        title = '';
    }
    return MsgBoxOwn(_extends({}, message, {
        title: title
    }));
};

MsgBoxOwn.qttConfirmShortCut.close = function () {
    //   debugger;
    instance.closePanel();
    instance.visible = false;
};

MsgBoxOwn.install = function (Vue, options) {
    Vue.prototype.$msgBoxOwn = MsgBoxOwn.qttConfirmShortCut;
};

exports.default = MsgBoxOwn;
exports.MsgBoxOwn = MsgBoxOwn;

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Query = {};

Query.install = function (Vue) {
    Vue.prototype.updateRouter = function (query) {
        if (!query) {
            query = this.queryFilter();
        }
        this.$router.replace({
            query: Object.assign({}, query)
        });
    };

    Vue.prototype.queryFilter = function () {
        var query = this.$route.query;
        var filter = this.filter || {};
        for (var i in filter) {
            if (typeof query[i] !== 'undefined') {
                if (typeof filter[i] === 'number') {
                    filter[i] = parseInt(query[i]);
                } else {
                    filter[i] = query[i];
                }
            }
        }
        return filter;
    };
};

exports.default = Query;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function ShortKey() {}

var mapFunction = {};

ShortKey.install = function (Vue, options) {
    Vue.directive('shortkey', {
        // 当绑定元素插入到 DOM 中。
        bind: function bind(el, binding) {
            var shortArray = binding.value;
            // console.log(binding)
            var input = el.querySelector('input');
            // let button = el.querySelector('button');
            var textArea = el.querySelector('textarea');
            if (input) {
                el = input;
            } else if (textArea) {
                el = textArea;
            }
            shortArray.forEach(function (item) {
                var short = item.toLocaleLowerCase();
                mapFunction['button-' + short] = {
                    shortKey: short,
                    element: el
                };
            });
        },
        unbind: function unbind(el, binding) {
            var short = binding.value.join('-');
            delete mapFunction['button-' + short];
        }
    });

    document.addEventListener('keyup', function (event) {
        var target = event.target;
        var nodeName = target.nodeName.toLocaleLowerCase();
        var flag = false;
        if (nodeName === 'textarea') flag = true;
        if (nodeName === 'input' && target.type !== ('radio' || 'submit' || 'button' || 'checkbox' || 'reset')) {
            flag = true;
        }
        if (event.code && event.code.indexOf('Numpad') > -1) flag = true; // 屏蔽全键盘，小键盘  触发
        // if (nodeName !== "input" && nodeName !== "textarea")
        if (!flag) {
            var key = event.key.toLocaleLowerCase();
            // ctrl + shift + alt + meta + code
            var keyCode = event.keyCode;
            if (keyCode >= 30 && keyCode <= 122) {
                key = String.fromCharCode(keyCode).toLocaleLowerCase();
            } else if (keyCode === 13) {
                key = 'enter';
            }

            var otherKey = '';
            if (event.ctrlKey) {
                otherKey = 'ctrl-' + otherKey;
            }
            if (event.shiftKey) {
                otherKey = 'shift-' + otherKey;
            }
            if (event.altKey) {
                otherKey = 'alt-' + otherKey;
            }
            if (event.metaKey) {
                otherKey = 'meta-' + otherKey;
            }
            var mapKey = 'button-' + otherKey + key;
            // console.log(key,mapKey, mapFunction)
            if (mapFunction[mapKey]) {
                var node = mapFunction[mapKey].element;
                // console.log(node)
                if (node.nodeName.toLocaleLowerCase() === 'textarea') {
                    node.focus();
                } else {
                    // let e = document.createEvent('HTMLEvents');
                    // e.initEvent('click', true, true);
                    // e.keyType = key;
                    // node.dispatchEvent(e);
                    node.setAttribute('data-key', key);
                    node.click();
                }
            }
        }
    });
};

exports.default = ShortKey;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(651);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _menu = __webpack_require__(181);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.use(_vueRouter2.default);

var isHistoryApi = !!(window.history && history.pushState);

exports.default = new _vueRouter2.default({
    mode: isHistoryApi ? 'history' : 'hash',
    // mode: 'hash', // Demo is living in GitHub.io, so required!
    linkActiveClass: 'is-active',
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: [{
        name: '登录',
        path: '/login',
        component: __webpack_require__(244)
    }, {
        name: '首页',
        path: '/',
        component: __webpack_require__(243)
    }].concat(_toConsumableArray(generateRoutesFromMenu(_menu2.default.state.items)), [{
        path: '*',
        redirect: '/'
    }])
});

// Menu should have 2 levels.

function generateRoutesFromMenu() {
    var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        if (item.path) {
            routes.push(item);
        }
        if (!item.component) {
            generateRoutesFromMenu(item.children, routes);
        }
    }
    return routes;
}

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(57);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(347);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(348);

var getters = _interopRequireWildcard(_getters);

var _app = __webpack_require__(349);

var _app2 = _interopRequireDefault(_app);

var _menu = __webpack_require__(181);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
var store = new _vuex2.default.Store({
    strict: true, // process.env.NODE_ENV !== 'production',
    actions: actions,
    getters: getters,
    modules: {
        app: _app2.default,
        menu: _menu2.default
    },
    state: {},
    mutations: {}
});

exports.default = store;

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)
__webpack_require__(607)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'nprogress-container'
};

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NprogressContainer = __webpack_require__(630);

var _NprogressContainer2 = _interopRequireDefault(_NprogressContainer);

var _layout = __webpack_require__(339);

var _vuex = __webpack_require__(57);

var _Debugger = __webpack_require__(180);

var _Debugger2 = _interopRequireDefault(_Debugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  data: function data() {
    return {
      isLong: false,
      scroll: 0
    };
  },

  components: {
    Navbar: _layout.Navbar,
    Sidebar: _layout.Sidebar,
    AppMain: _layout.AppMain,
    FooterBar: _layout.FooterBar,
    NprogressContainer: _NprogressContainer2.default,
    BackTop: _layout.BackTop
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar(!isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('keyup', function (e) {
      var keyCode = e.keyCode || e.which || e.charCode;
      if (e.altKey && e.shiftKey && (keyCode === 76 || keyCode === 108)) {
        _Debugger2.default.download('调试数据');
      }
    });
    window.addEventListener('scroll', function () {
      _this2.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (window.innerHeight) {
        _this2.winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        _this2.winHeight = document.body.clientHeight;
      }
      if (_this2.scroll > _this2.winHeight / 2) {
        _this2.isLong = true;
      } else {
        _this2.isLong = false;
      }
    });
  },


  computed: (0, _vuex.mapGetters)({
    sidebar: 'sidebar',
    isLogin: 'isLogin',
    isAuditDetail: 'isAuditDetail'
  }),

  methods: (0, _vuex.mapActions)(['toggleDevice', 'toggleSidebar'])
};

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Levelbar = __webpack_require__(635);

var _Levelbar2 = _interopRequireDefault(_Levelbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        Levelbar: _Levelbar2.default
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    },

    methods: {
        backTop: function backTop() {
            window.pageYOffset = 0;
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }
    }
};

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    methods: {
        beforeEnter: function beforeEnter(el) {
            el.classList.remove('collapse');
            el.style.display = 'block';
            el.classList.add('collapsing');
            el.style.height = el.scrollHeight + 'px';
        },
        afterEnter: function afterEnter(el) {
            el.classList.remove('collapsing');
            el.classList.add('collapse', 'in');
        },
        beforeLeave: function beforeLeave(el) {
            el.classList.add('collapsing');
            el.classList.remove('collapse', 'in');
            el.style.height = 0;
        },
        afterLeave: function afterLeave(el) {
            el.classList.remove('collapsing');
            el.classList.add('collapse');
            el.style.display = 'none';
        }
    }
};

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    }
};

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {},

    data: function data() {
        return {
            list: null
        };
    },
    created: function created() {
        this.getList();
    },


    computed: {
        label: function label() {
            return this.$route.meta.label || this.$route.name;
        }
    },

    methods: {
        getList: function getList() {
            var matched = this.$route.matched;
            var first = matched[0];
            if (first && first.name !== '登录' && first.name !== '首页') {
                matched = [{ meta: { label: '首页' }, path: '/home' }].concat(matched);
            }
            this.list = matched;
        }
    },

    watch: {
        $route: function $route() {
            this.getList();
        }
    }
};

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


var _vuex = __webpack_require__(57);

var _mutationTypes = __webpack_require__(55);

var MutationTypes = _interopRequireWildcard(_mutationTypes);

var _ewxLoginSdk = __webpack_require__(78);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

var _QuRequest = __webpack_require__(66);

var _QuRequest2 = _interopRequireDefault(_QuRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var quRequest = new _QuRequest2.default();

var branchMap = quRequest.getBranch();

// console.log(branchMap)

exports.default = {
  components: {},

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      dev: {
        isShow: false,
        qk: '',
        qp: '',
        audit: '',
        author: ''
      }
    };
  },


  computed: (0, _vuex.mapGetters)({
    sidebar: 'sidebar',
    isLogin: 'isLogin',
    user: 'getUser'
  }),

  methods: _extends({}, (0, _vuex.mapActions)(['toggleSidebar']), {
    logout: function logout() {
      var $store = this.$store,
          $router = this.$router;

      _ewxLoginSdk2.default.logout({ isPerm: true }).then(function (res) {
        $store.commit(MutationTypes.SET_TOKEN, '');
        $store.commit(MutationTypes.LOGIN_USER, {
          id: '',
          name: ''
        });
      });
    },
    reloadPage: function reloadPage() {
      window.location && window.location.reload(true);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var $store = this.$store,
        dev = this.dev;

    if (false) {
      dev.isShow = true;
      dev.tagging = branchMap['tagging'] || '';
      // dev.qp = branchMap['qupost'] || ''
      // dev.audit = branchMap['audit'] || ''
      // dev.comment = branchMap['comment'] || ''
      // dev.online_content = branchMap['online_content'] || ''
      // dev.author = branchMap['author'] || ''
    }
    if (this.isLogin) {
      quRequest.send(quRequest.Apis.perm.member.getMember).then(function (_ref) {
        var data = _ref.data;

        if (data && data.member && data.member.id) {
          _this.id = data.member.id;
          _this.name = data.member.name;
          $store.commit(MutationTypes.LOGIN_USER, {
            id: data.member.id,
            name: data.member.name
          });
          _this.$http.send(_this.$http.Apis.bzxt.user.login, {
            user_name: data.member.name
          }).then(function (res) {}).catch(function (err) {
            _this.$message.error('\u8BB0\u5F55\u7528\u6237\u767B\u5F55\u4FE1\u606F\u4FE1\u606F\u5931\u8D25\uFF1A' + (err.message || '未知错误'));
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _Expanding = __webpack_require__(633);

var _Expanding2 = _interopRequireDefault(_Expanding);

var _vuex = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        Expanding: _Expanding2.default
    },

    props: {
        show: Boolean
    },

    data: function data() {
        return {
            isReady: false,
            selectedMenu: '',
            isSubMenu: false
        };
    },
    mounted: function mounted() {
        var route = this.$route;
        if (route.name) {
            this.isReady = true;
            this.shouldExpandMatchItem(route);
        }
    },


    computed: (0, _vuex.mapGetters)({
        menu: 'menuitems'
    }),

    methods: _extends({}, (0, _vuex.mapActions)(['expandMenu']), {
        childPerm: function childPerm(_childPerm) {
            var has = true;
            if (_childPerm) {
                has = _childPerm.some(function (child) {
                    if (child.meta.nomenu) {
                        return false;
                    }
                    return true;
                });
            }
            return has;
        },
        isExpanded: function isExpanded(item) {
            return item.meta.expanded;
        },
        toggle: function toggle(index, item) {
            this.expandMenu({
                index: index,
                expanded: !item.meta.expanded
            });
        },
        shouldExpandMatchItem: function shouldExpandMatchItem(route) {
            var matched = route.matched;
            var lastMatched = matched[matched.length - 1];
            var parent = lastMatched.parent || lastMatched;
            var isParent = parent === lastMatched;

            if (isParent) {
                var p = this.findParentFromMenu(route);
                if (p) {
                    parent = p;
                }
            }

            if ('expanded' in parent.meta && !isParent) {
                this.expandMenu({
                    item: parent,
                    expanded: true
                });
            }
        },
        generatePath: function generatePath(item, subItem) {
            return '' + (item.component ? item.path + '/' : '') + subItem.path;
        },
        findParentFromMenu: function findParentFromMenu(route) {
            var menu = this.menu;
            for (var i = 0, l = menu.length; i < l; i++) {
                var item = menu[i];
                var k = item.children && item.children.length;
                if (k) {
                    for (var j = 0; j < k; j++) {
                        if (item.children[j].name === route.name) {
                            return item;
                        }
                    }
                }
            }
        }
    }),

    watch: {
        $route: function $route(route) {
            this.isReady = true;
            this.isSubMenu = false; // 菜单切换重置
            if (route.meta && route.meta.parent) {
                this.selectedMenu = route.meta.parent;
                this.isSubMenu = true; // 标记是子菜单
            }
            this.shouldExpandMatchItem(route);
        }
    }
};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _popup = __webpack_require__(322);

var _popup2 = _interopRequireDefault(_popup);

var _locale = __webpack_require__(321);

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    mixins: [_popup2.default, _locale2.default],

    props: {
        modal: {
            default: true
        },
        lockScroll: {
            default: true
        },
        showClose: {
            type: Boolean,
            default: true
        },
        closeOnClickModal: {
            default: true
        },
        closeOnPressEscape: {
            default: true
        }
    },
    data: function data() {
        return {
            // visible: false,
            title: '',
            content: '',
            shortCut: true,
            action: '',
            showInput: false
        };
    },

    methods: {
        showPanel: function showPanel() {
            this.visible = true;
        },
        getSafeClose: function getSafeClose() {
            var _this = this;

            var currentId = this.uid;
            return function () {
                _this.$nextTick(function () {
                    if (currentId === _this.uid) _this.doClose();
                });
            };
        },
        doClose: function doClose() {
            var _this2 = this;

            if (!this.visible) return;
            this.visible = false;
            this._closing = true;

            this.onClose && this.onClose();

            if (this.lockScroll) {
                setTimeout(function () {
                    if (_this2.modal && _this2.bodyOverflow !== 'hidden') {
                        document.body.style.overflow = _this2.bodyOverflow;
                        document.body.style.paddingRight = _this2.bodyPaddingRight;
                    }
                    _this2.bodyOverflow = null;
                    _this2.bodyPaddingRight = null;
                }, 200);
            }
            this.opened = false;

            if (!this.transition) {
                this.doAfterClose();
            }
            if (this.action) this.callback(this.action, this);
        },
        closePanel: function closePanel(action) {
            var _this3 = this;

            if (!this.visible) return;
            this.visible = false;
            this._closing = true;
            this.action = action;
            this.onClose && this.onClose();

            if (this.lockScroll) {
                setTimeout(function () {
                    if (_this3.modal && _this3.bodyOverflow !== 'hidden') {
                        document.body.style.overflow = _this3.bodyOverflow;
                        document.body.style.paddingRight = _this3.bodyPaddingRight;
                    }
                    _this3.bodyOverflow = null;
                    _this3.bodyPaddingRight = null;
                }, 200);
            }
            this.opened = false;

            if (!this.transition) {
                this.doAfterClose();
            }
            if (this.action) this.callback(this.action, this);
        }
    },
    mounted: function mounted() {
        var self = this;
        document.addEventListener('keyup', function (evt) {
            // debugger;
            if (evt.keyCode === 27) {
                self.action = 'cancel';
                self.onClose && self.onClose();
                self.callback(self.action, self);
            }
        });
    }
};

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(57);

exports.default = {
    computed: (0, _vuex.mapGetters)({
        menu: 'menuitems'
    }),
    data: function data() {
        return {};
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//

/* eslint-disable */


var _vuex = __webpack_require__(57);

var _mutationTypes = __webpack_require__(55);

var MutationTypes = _interopRequireWildcard(_mutationTypes);

var _q = __webpack_require__(237);

var _q2 = _interopRequireDefault(_q);

var _QuRequest = __webpack_require__(66);

var _QuRequest2 = _interopRequireDefault(_QuRequest);

var _ewxLoginSdk = __webpack_require__(78);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var quRequest = new _QuRequest2.default();

var QU_LOCAL_PERMS = 'qu_local_perms';
var PERM_LOAING_TEXT = '登陆成功，正在获取权限中...';

exports.default = {
  data: function data() {
    return {};
  },

  computed: _extends({}, (0, _vuex.mapGetters)({
    menu: 'menuitems'
  })),
  methods: {
    authentication: function authentication() {
      return _q2.default.resolve(this.getPermUris(this.menu)).then(function (uris) {
        if (!uris.length) {
          return [];
        } else {
          return quRequest.send(quRequest.Apis.perm.member.checkPerm, {
            project_uri: uris.join(','),
            project: 'tagging'
          }).then(function (_ref) {
            var perm = _ref.data.perm;

            var perms = [];
            for (var key in perm) {
              var _perm$key = perm[key],
                  has = _perm$key.has,
                  name = _perm$key.name;

              var _key$split = key.split('::'),
                  _key$split2 = _slicedToArray(_key$split, 2),
                  project = _key$split2[0],
                  uri = _key$split2[1];

              perms.push({
                uri: uri,
                has: has,
                name: name,
                project: project
              });
            }
            return perms;
          });
        }
      });
    },
    getPermUris: function getPermUris(menu) {
      var _this = this;

      var uris = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      menu.forEach(function (menuItem) {
        var _menuItem$meta = menuItem.meta,
            meta = _menuItem$meta === undefined ? {} : _menuItem$meta;
        var _meta$auth = meta.auth,
            auth = _meta$auth === undefined ? {} : _meta$auth;

        if (auth.needApis) {
          auth.needApis.forEach(function (perm) {
            uris.push(perm.project + '::' + perm.path);
          });
        }
        if (menuItem.children) {
          _this.getPermUris(menuItem.children, uris);
        }
      });
      return uris;
    },
    tokenLogin: function tokenLogin(token) {
      this.$store.commit(MutationTypes.SET_TOKEN, token);
      return this.sendAuthentication().catch(function (err) {
        $message.error('\u767B\u9646\u5931\u8D25\uFF1A' + err.message);
        throw err;
      }).done();
    },
    sendAuthentication: function sendAuthentication() {
      var _this2 = this;

      this.$message.info(PERM_LOAING_TEXT);
      return this.authentication().then(function (perms) {
        if (perms) {
          localStorage.setItem(QU_LOCAL_PERMS, JSON.stringify(perms));
        }
        _this2.$router.push('/');
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var login = function login() {
      var copyright = {};
      _ewxLoginSdk2.default.login({
        project: 'tagging',
        url: location.href,
        qa: !quRequest.isProduct(),
        copyright: JSON.stringify(copyright)
      });
    };
    _ewxLoginSdk2.default.getUserInfo({ isPerm: true }).then(function (res) {
      if (!res) {
        login();
      } else {
        var token = _ewxLoginSdk2.default.getToken({ isPerm: true });
        if (!token) {
          login();
        } else {
          _this3.$store.commit(MutationTypes.LOGIN_USER, {
            id: res.id,
            name: res.name
          });
          _this3.tokenLogin(token);
        }
      }
    }, function (rej) {
      login();
    });
  }
};

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackTop = exports.FooterBar = exports.AppMain = exports.Sidebar = exports.Navbar = undefined;

var _Navbar2 = __webpack_require__(636);

var _Navbar3 = _interopRequireDefault(_Navbar2);

var _Sidebar2 = __webpack_require__(637);

var _Sidebar3 = _interopRequireDefault(_Sidebar2);

var _AppMain2 = __webpack_require__(631);

var _AppMain3 = _interopRequireDefault(_AppMain2);

var _FooterBar2 = __webpack_require__(634);

var _FooterBar3 = _interopRequireDefault(_FooterBar2);

var _BackTop2 = __webpack_require__(632);

var _BackTop3 = _interopRequireDefault(_BackTop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Navbar = _Navbar3.default;
exports.Sidebar = _Sidebar3.default;
exports.AppMain = _AppMain3.default;
exports.FooterBar = _FooterBar3.default;
exports.BackTop = _BackTop3.default;

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApiInfo2 = __webpack_require__(79);

var _ApiInfo3 = _interopRequireDefault(_ApiInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var version = '/v1';

var CrowdApiInfo = function (_ApiInfo) {
    _inherits(CrowdApiInfo, _ApiInfo);

    function CrowdApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            headers = _ref.headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'crowd' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, CrowdApiInfo);

        return _possibleConstructorReturn(this, (CrowdApiInfo.__proto__ || Object.getPrototypeOf(CrowdApiInfo)).call(this, {
            path: path,
            type: type,
            timeout: timeout,
            headers: headers,
            project: project,
            author: author
        }));
    }

    return CrowdApiInfo;
}(_ApiInfo3.default);

exports.default = {
    manage: {
        setTaskConfig: new CrowdApiInfo({
            // 修改配置,4.2
            path: version + '/task/config',
            type: 'post',
            author: '高国栋'
        }),
        setTaskRate: new CrowdApiInfo({
            // 修改任务质检比例,4.3
            path: version + '/task/rate',
            type: 'post',
            author: '高国栋'
        }),
        getAllData: new CrowdApiInfo({
            // 质检数据统计,4.4
            path: version + '/task/data',
            type: 'get',
            author: '张振胜'
        }),
        getSearchList: new CrowdApiInfo({
            // 质检结果搜索,4.5
            path: version + '/search',
            type: 'get',
            author: '孙万成'
        }),
        exportSearchList: new CrowdApiInfo({
            // 质检结果搜索,4.6
            path: version + '/exportSearch',
            type: 'get',
            author: '张振胜'
        }),
        getSubjectDetail: new CrowdApiInfo({
            // 查看质检结果详情,4.7
            path: version + '/subject/detail',
            type: 'get',
            author: '张振胜'
        }),
        getSubjectInfo: new CrowdApiInfo({
            // 运营质检,4.8
            path: version + '/subject/info',
            type: 'get',
            author: '张振胜'
        }),
        submitSubject: new CrowdApiInfo({
            // 提交质检结果,4.9
            path: version + '/subject/submit',
            type: 'post',
            author: '张振胜'
        }),
        getDataList: new CrowdApiInfo({
            // 众包打标签数据总览,4.10
            path: version + '/statisticsList',
            type: 'get',
            author: '孙万成'
        }),
        importData: new CrowdApiInfo({
            // 众包打标导出,4.11
            path: version + '/exportStatisticsList',
            type: 'get',
            author: '孙万成'
        }),
        getPaskList: new CrowdApiInfo({
            // 聚合任务列表,4.12
            path: version + '/p_task/list',
            type: 'get',
            author: '张振胜'
        }),
        getTaskList: new CrowdApiInfo({
            // 任务列表,4.13
            path: version + '/task/list',
            type: 'get',
            author: '张振胜'
        }),
        clearTaskList: new CrowdApiInfo({
            // 任务列表,4.13
            path: version + '/task/list',
            type: 'get',
            author: '张振胜'
        }),
        cleanTask: new CrowdApiInfo({
            // 清空队列,4.14
            path: version + '/task/clean',
            type: 'post',
            author: '张振胜'
        }),
        getTaskConfig: new CrowdApiInfo({
            // 查看任务配置,4.14
            path: version + '/task/show_config',
            type: 'get',
            author: '高国栋'
        })
    }
};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApiInfo2 = __webpack_require__(79);

var _ApiInfo3 = _interopRequireDefault(_ApiInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuKanPermApiInfo = function (_ApiInfo) {
    _inherits(QuKanPermApiInfo, _ApiInfo);

    function QuKanPermApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            headers = _ref.headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'perm' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, QuKanPermApiInfo);

        return _possibleConstructorReturn(this, (QuKanPermApiInfo.__proto__ || Object.getPrototypeOf(QuKanPermApiInfo)).call(this, {
            path: path,
            type: type,
            timeout: timeout,
            headers: headers,
            project: project,
            author: author
        }));
    }

    return QuKanPermApiInfo;
}(_ApiInfo3.default);

exports.default = {
    member: {
        list: new QuKanPermApiInfo({
            path: '/member/list',
            type: 'get',
            author: '刘彪'
        }),
        getMember: new QuKanPermApiInfo({
            path: '/member/getMember',
            type: 'get',
            author: '刘彪'
        }),
        allowLogin: new QuKanPermApiInfo({
            path: '/member/allowLogin',
            type: 'post',
            author: '刘彪'
        }),
        login: new QuKanPermApiInfo({
            path: '/member/login',
            type: 'get',
            author: '刘彪'
        }),
        loginByPwd: new QuKanPermApiInfo({
            path: '/member/loginByPwd',
            type: 'get',
            author: '刘彪'
        }),
        loginByTelephone: new QuKanPermApiInfo({
            path: '/member/loginByTelephone',
            type: 'get',
            author: '袁路'
        }),
        checkPerm: new QuKanPermApiInfo({
            path: '/member/checkPerm',
            type: 'post',
            author: '刘彪'
        })
    },
    perm: {
        list: new QuKanPermApiInfo({
            path: '/perm/getPermGroupList',
            type: 'post',
            author: '刘彪'
        })
    }
};

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApiInfo2 = __webpack_require__(79);

var _ApiInfo3 = _interopRequireDefault(_ApiInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuKanSearchApiInfo = function (_ApiInfo) {
    _inherits(QuKanSearchApiInfo, _ApiInfo);

    function QuKanSearchApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            headers = _ref.headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'search' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, QuKanSearchApiInfo);

        return _possibleConstructorReturn(this, (QuKanSearchApiInfo.__proto__ || Object.getPrototypeOf(QuKanSearchApiInfo)).call(this, {
            path: path,
            type: type,
            timeout: timeout,
            headers: headers,
            project: project,
            author: author
        }));
    }

    return QuKanSearchApiInfo;
}(_ApiInfo3.default);

exports.default = {
    innersearch: new QuKanSearchApiInfo({
        path: '/search/algorithm/searchDistributionTag',
        type: 'get',
        author: '魏文平'
    })
};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApiInfo2 = __webpack_require__(79);

var _ApiInfo3 = _interopRequireDefault(_ApiInfo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BzxtApiInfo = function (_ApiInfo) {
    _inherits(BzxtApiInfo, _ApiInfo);

    function BzxtApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 10000 : _ref$timeout,
            headers = _ref.headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'tagging' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, BzxtApiInfo);

        return _possibleConstructorReturn(this, (BzxtApiInfo.__proto__ || Object.getPrototypeOf(BzxtApiInfo)).call(this, {
            path: path,
            type: type,
            timeout: timeout,
            headers: headers,
            project: project,
            author: author
        }));
    }

    return BzxtApiInfo;
}(_ApiInfo3.default);

exports.default = {
    user: {
        login: new BzxtApiInfo({
            path: '/user/login',
            type: 'get',
            author: '密勃祥'
        }),
        list: new BzxtApiInfo({
            path: '/user/getReadyAdminList',
            type: 'get',
            author: '密勃祥'
        })
    },
    mission: {
        getLog: new BzxtApiInfo({
            path: '/mission/getLog',
            type: 'get',
            author: '孙万成'
        }),
        list: new BzxtApiInfo({
            path: '/mission/list',
            type: 'get',
            author: '密勃祥'
        }),
        delete: new BzxtApiInfo({
            path: '/mission/delete',
            type: 'get',
            author: '密勃祥'
        }),
        add: new BzxtApiInfo({
            path: '/mission/add',
            type: 'post',
            author: '密勃祥'
        }),
        uploadCsv: new BzxtApiInfo({
            path: '/mission/uploadCsv',
            type: 'post',
            author: '密勃祥'
        }),
        detail: new BzxtApiInfo({
            path: '/mission/detail',
            type: 'get',
            author: '密勃祥'
        }),
        save: new BzxtApiInfo({
            path: '/mission/save',
            type: 'post',
            author: '密勃祥'
        }),
        publish: new BzxtApiInfo({
            path: '/mission/publish',
            type: 'get',
            author: '密勃祥'
        }),
        submitAnswer: new BzxtApiInfo({
            path: '/mission/submitAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        getTaggingInfo: new BzxtApiInfo({
            path: '/mission/getTaggingInfo',
            type: 'get',
            author: '密勃祥'
        }),
        remotesearch: new BzxtApiInfo({
            path: '/QuestionApi/getOtherAnswerList',
            type: 'get',
            author: '孙万成'
        })
    },
    task: {
        follow: new BzxtApiInfo({
            path: '/task/follow',
            type: 'post',
            author: '孙万成'
        }),
        myFollow: new BzxtApiInfo({
            path: '/task/myFollow',
            type: 'get',
            author: '密勃祥'
        }),
        missionList: new BzxtApiInfo({
            path: '/task/missionList',
            type: 'get',
            author: '密勃祥'
        }),
        receiveTask: new BzxtApiInfo({
            path: '/task/receiveTask',
            type: 'get',
            author: '密勃祥'
        }),
        taskList: new BzxtApiInfo({
            path: '/task/taskList',
            type: 'get',
            author: '密勃祥'
        }),
        finishTask: new BzxtApiInfo({
            path: '/task/finishTask',
            type: 'get',
            author: '密勃祥'
        }),
        returnTagging: new BzxtApiInfo({
            path: '/task/returnTagging',
            type: 'get',
            author: '密勃祥'
        }),
        getReadyInfo: new BzxtApiInfo({
            path: '/task/getReadyInfo',
            type: 'get',
            author: '密勃祥'
        }),
        submitReadyAnswer: new BzxtApiInfo({
            path: '/task/submitReadyAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        submitTaggingAnswer: new BzxtApiInfo({
            path: '/task/submitTaggingAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        getTaggingInfo: new BzxtApiInfo({
            path: '/task/getTaggingInfo',
            type: 'get',
            author: '密勃祥'
        }),
        addReadyTaggingTask: new BzxtApiInfo({
            path: '/task/addReadyTaggingTask',
            type: 'get',
            author: '密勃祥'
        }),
        errorList: new BzxtApiInfo({
            path: '/task/errorList',
            type: 'get',
            author: '密勃祥'
        }),
        getErrorInfo: new BzxtApiInfo({
            path: '/task/getErrorInfo',
            type: 'get',
            author: '密勃祥'
        })
    },
    downloadTask: {
        addDownloadTask: new BzxtApiInfo({
            path: '/downloadTask/addDownloadTask',
            type: 'get',
            author: '密勃祥'
        }),
        downloadTaskList: new BzxtApiInfo({
            path: '/downloadTask/downloadTaskList',
            type: 'get',
            author: '密勃祥'
        }),
        downloadFile: new BzxtApiInfo({
            path: '/downloadTask/downloadFile',
            type: 'get',
            author: '密勃祥'
        })
    },
    training: {
        getNextTraining: new BzxtApiInfo({
            path: '/training/getNextTraining',
            type: 'post',
            author: '密勃祥'
        }),
        add: new BzxtApiInfo({
            path: '/training/add',
            type: 'get',
            author: '密勃祥'
        })
    },
    quality: {
        missionList: new BzxtApiInfo({
            path: '/quality/missionList',
            type: 'get',
            author: '密勃祥'
        }),
        missionInfo: new BzxtApiInfo({
            path: '/quality/missionInfo',
            type: 'get',
            author: '密勃祥'
        }),
        qualityErrorList: new BzxtApiInfo({
            path: '/quality/qualityErrorList',
            type: 'get',
            author: '密勃祥'
        }),
        crossErrorList: new BzxtApiInfo({
            path: '/quality/crossErrorList',
            type: 'get',
            author: '密勃祥'
        }),
        getTaggingInfo: new BzxtApiInfo({
            path: '/quality/getTaggingInfo',
            type: 'get',
            author: '密勃祥'
        }),
        crossErrorMissionList: new BzxtApiInfo({
            path: '/quality/crossErrorMissionList',
            type: 'get',
            author: '密勃祥'
        }),
        qualityErrorMissionList: new BzxtApiInfo({
            path: '/quality/qualityErrorMissionList',
            type: 'get',
            author: '密勃祥'
        }),
        getQualityErrorInfo: new BzxtApiInfo({
            path: '/quality/getQualityErrorInfo',
            type: 'get',
            author: '密勃祥'
        }),
        submitAnswer: new BzxtApiInfo({
            path: '/quality/submitAnswer',
            type: 'get',
            author: '密勃祥'
        }),
        returnMissionTagging: new BzxtApiInfo({
            path: '/quality/returnMissionTagging',
            type: 'get',
            author: '密勃祥'
        }),
        taskList: new BzxtApiInfo({
            path: '/quality/taskList',
            type: 'get',
            author: '密勃祥'
        }),
        qualityList: new BzxtApiInfo({
            path: '/quality/qualityList',
            type: 'get',
            author: '密勃祥'
        }),
        submitQualityAnswer: new BzxtApiInfo({
            path: '/quality/submitQualityAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        getQualityInfo: new BzxtApiInfo({
            path: '/quality/getQualityInfo',
            type: 'get',
            author: '密勃祥'
        }),
        qcTaskList: new BzxtApiInfo({
            path: '/qualitynew/taskList',
            type: 'post',
            author: '张振胜'
        }),
        qcTaskDetail: new BzxtApiInfo({
            path: '/qualitynew/taskDataList',
            type: 'post',
            author: '张振胜'
        }),
        qcNewDetail: new BzxtApiInfo({
            path: '/qualitynew/detail',
            type: 'post',
            author: '张振胜'
        }),
        qcNewSubmit: new BzxtApiInfo({
            path: '/qualitynew/submit',
            type: 'post',
            author: '张振胜'
        }),
        qcReport: new BzxtApiInfo({
            path: '/report/addClick',
            type: 'post',
            author: '张振胜'
        })
    },
    cross: {
        getCrossErrorInfo: new BzxtApiInfo({
            path: '/cross/getCrossErrorInfo',
            type: 'get',
            author: '密勃祥'
        }),
        getMissionCrossInfo: new BzxtApiInfo({
            path: '/cross/getMissionCrossInfo',
            type: 'get',
            author: '密勃祥'
        })
    },
    admin: {
        getmissiondatalist: new BzxtApiInfo({
            path: '/mission/getmissiondatalist',
            type: 'get',
            author: '孙万成'
        }),
        getmissiondatainfo: new BzxtApiInfo({
            path: '/mission/getmissiondatainfo',
            type: 'get',
            author: '孙万成'
        }),
        reviewanswer: new BzxtApiInfo({
            path: '/mission/reviewanswer',
            type: 'post',
            author: '孙万成'
        }),
        endmission: new BzxtApiInfo({
            path: '/mission/endmission',
            type: 'post',
            author: '孙万成'
        })
    }
};

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check


var _axios = __webpack_require__(170);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(239);

var _qs2 = _interopRequireDefault(_qs);

var _q = __webpack_require__(237);

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
_axios2.default.defaults.withCredentials = false;

var BaseRequest = function () {
    function BaseRequest() {
        _classCallCheck(this, BaseRequest);
    }

    _createClass(BaseRequest, [{
        key: 'send',
        value: function send(_ref) {
            var url = _ref.url,
                _ref$type = _ref.type,
                type = _ref$type === undefined ? 'get' : _ref$type,
                _ref$timeout = _ref.timeout,
                timeout = _ref$timeout === undefined ? 10000 : _ref$timeout,
                _ref$headers = _ref.headers,
                headers = _ref$headers === undefined ? {} : _ref$headers;
            var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var options = {
                url: url,
                timeout: timeout,
                headers: headers,
                method: type.toLocaleLowerCase()
            };
            try {
                // 处理 post 参数格式
                if (options.method === 'post') {
                    options.data = _qs2.default.stringify(body);
                } else if (options.method === 'get') {
                    options.params = body;
                } else {
                    options.data = body;
                }
                return _q2.default.resolve((0, _axios2.default)(options));
            } catch (e) {
                _q2.default.reject(e);
            }
        }
    }]);

    return BaseRequest;
}();

exports.default = BaseRequest;

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataCenterLog = function () {
    function DataCenterLog() {
        _classCallCheck(this, DataCenterLog);
    }

    _createClass(DataCenterLog, null, [{
        key: 'send',
        value: function send(_ref) {
            var _ref$cmd = _ref.cmd,
                cmd = _ref$cmd === undefined ? 9010 : _ref$cmd,
                _ref$item = _ref.item,
                item = _ref$item === undefined ? '' : _ref$item,
                _ref$action = _ref.action,
                action = _ref$action === undefined ? '' : _ref$action,
                _ref$pageId = _ref.pageId,
                pageId = _ref$pageId === undefined ? '' : _ref$pageId,
                _ref$pos = _ref.pos,
                pos = _ref$pos === undefined ? '' : _ref$pos,
                _ref$uid = _ref.uid,
                uid = _ref$uid === undefined ? '' : _ref$uid;

            var query = [];
            var arg = arguments[0] || {};
            var option = _extends({
                cmd: cmd,
                item: item,
                action: action,
                pageId: pageId,
                pos: pos,
                uid: uid
            }, arg);
            for (var key in option) {
                query.push(key + '=' + option[key]);
            }
            // new Image().src = path + query.join('&');
        }
    }]);

    return DataCenterLog;
}();

exports.default = DataCenterLog;

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(251);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

__webpack_require__(255);

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(249);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(250);

var _store2 = _interopRequireDefault(_store);

var _App = __webpack_require__(258);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(252);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _ewxLoginSdk = __webpack_require__(78);

var _ewxLoginSdk2 = _interopRequireDefault(_ewxLoginSdk);

__webpack_require__(256);

var _vuexRouterSync = __webpack_require__(259);

var _Auth = __webpack_require__(76);

var _Auth2 = _interopRequireDefault(_Auth);

var _Query = __webpack_require__(247);

var _Query2 = _interopRequireDefault(_Query);

var _Api = __webpack_require__(245);

__webpack_require__(253);

var _ApiDomain = __webpack_require__(106);

var _ApiDomain2 = _interopRequireDefault(_ApiDomain);

var _QuRequest = __webpack_require__(66);

var _QuRequest2 = _interopRequireDefault(_QuRequest);

var _nprogress = __webpack_require__(257);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(254);

var _ShortKey = __webpack_require__(248);

var _ShortKey2 = _interopRequireDefault(_ShortKey);

var _MessageBoxOwn = __webpack_require__(246);

var _MessageBoxOwn2 = _interopRequireDefault(_MessageBoxOwn);

var _mutationTypes = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
_nprogress2.default.configure({
    easing: 'ease', // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
});

_vue2.default.use(_elementUi2.default);
// Vue.use(Router)
_vue2.default.router = _router2.default;
_vue2.default.use(_ShortKey2.default);
_vue2.default.use(_Query2.default);

_vue2.default.use(_MessageBoxOwn2.default);
// Enable devtools
_vue2.default.config.devtools = true;

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_vue2.default.prototype.$http = new _QuRequest2.default();

var state = _store2.default.state;

// 从 cookie 中恢复 token

_store2.default.commit(_mutationTypes.SET_TOKEN, _Auth2.default.getToken());

// const router = new Router(routerMap)

_router2.default.beforeEach(function (to, from, next) {
    _Api.Api.update(to.query);
    _ApiDomain2.default.setApiBranch(to.query);
    if (state.app.device.isMobile && state.app.sidebar.opened) {
        _store2.default.commit(_mutationTypes.TOGGLE_SIDEBAR, false);
    }
    _nprogress2.default.start();
    if (to.fullPath === '/login' || from.fullPath === '/login') {
        next();
    } else {
        _ewxLoginSdk2.default.getUserInfo({ isPerm: true }).then(function (res) {
            if (!res) {
                next('/login');
            } else {
                next();
            }
        });
    }
});
_router2.default.afterEach(function () {
    // 在即将进入新的页面组件前，关闭掉进度条
    _nprogress2.default.done();
});

_vue2.default.mixin({
    created: function created() {
        if (this.filter) {
            this.filter = this.queryFilter();
            this.updateRouter(this.filter);
        }
    },

    methods: {
        $blockRequest: function $blockRequest(_ref) {
            var $elem = _ref.$elem,
                req = _ref.req,
                _ref$pendingText = _ref.pendingText,
                pendingText = _ref$pendingText === undefined ? '操作中' : _ref$pendingText;

            if (!$elem) {
                $elem = document.createElement('button');
            }
            if (!$elem || $elem._req_block) return;

            var isButton = $elem.nodeName.toLowerCase() === 'button';
            var oText = $elem.innerText;

            if (isButton) $elem.setAttribute('disabled', true);

            $elem.innerText = pendingText;
            $elem._req_block = true;

            return req.fin(function () {
                if (isButton) $elem.removeAttribute('disabled');
                $elem._req_block = false;
                $elem.innerText = oText;
            });
        }
    }
});

// Warn if overriding existing method
if (Array.prototype.equals) {
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
}
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array) {
        return false;
    }

    // compare lengths - can save a lot of time
    if (this.length !== array.length) {
        return false;
    }

    for (var i = 0, l = this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i])) {
                return false;
            }
        } else if (this[i] !== array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
};
// Hide method from for-in loops
Object.defineProperty(Array.prototype, 'equals', { enumerable: false });

new _vue2.default({
    router: _router2.default,
    store: _store2.default,
    // i18n,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleNoMenu = exports.setUser = exports.setToken = exports.switchEffect = exports.expandMenu = exports.toggleDevice = exports.toggleSidebar = undefined;

var _mutationTypes = __webpack_require__(55);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var toggleSidebar = exports.toggleSidebar = function toggleSidebar(_ref, opened) {
    var commit = _ref.commit;
    return commit(types.TOGGLE_SIDEBAR, opened);
};

var toggleDevice = exports.toggleDevice = function toggleDevice(_ref2, device) {
    var commit = _ref2.commit;
    return commit(types.TOGGLE_DEVICE, device);
};

var expandMenu = exports.expandMenu = function expandMenu(_ref3, menuItem) {
    var commit = _ref3.commit;

    if (menuItem) {
        menuItem.expanded = menuItem.expanded || false;
        commit(types.EXPAND_MENU, menuItem);
    }
};

var switchEffect = exports.switchEffect = function switchEffect(_ref4, effectItem) {
    var commit = _ref4.commit;

    if (effectItem) {
        commit(types.SWITCH_EFFECT, effectItem);
    }
};

var setToken = exports.setToken = function setToken(_ref5, token) {
    var commit = _ref5.commit;
    return commit(types.SET_TOKEN, token);
};

var setUser = exports.setUser = function setUser(_ref6, user) {
    var commit = _ref6.commit;
    return commit(types.LOGIN_USER, user);
};

var toggleNoMenu = exports.toggleNoMenu = function toggleNoMenu(_ref7, _ref8) {
    var commit = _ref7.commit;
    var menuItem = _ref8.menuItem,
        nomenu = _ref8.nomenu;
    return commit(types.TOGGLE_NO_MENU, { menuItem: menuItem, nomenu: nomenu });
};

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var app = function app(state) {
    return state.app;
};
var device = function device(state) {
    return state.app.device;
};
var sidebar = function sidebar(state) {
    return state.app.sidebar;
};
var effect = function effect(state) {
    return state.app.effect;
};
var menuitems = function menuitems(state) {
    return state.menu.items;
};
var isLogin = function isLogin(state) {
    return !!state.app.token;
};
var componententry = function componententry(state) {
    return state.menu.items.filter(function (c) {
        return c.meta && c.meta.label === 'Components';
    })[0];
};

var getUser = function getUser(state) {
    return state.app.user;
};

var isAuditDetail = function isAuditDetail(state) {
    return state.app.isAuditDetail;
};

exports.app = app;
exports.device = device;
exports.sidebar = sidebar;
exports.effect = effect;
exports.menuitems = menuitems;
exports.componententry = componententry;
exports.isLogin = isLogin;
exports.getUser = getUser;
exports.isAuditDetail = isAuditDetail;

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mutations;

var _mutationTypes = __webpack_require__(55);

var types = _interopRequireWildcard(_mutationTypes);

var _jsCookie = __webpack_require__(75);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var state = {
    device: {
        isMobile: false,
        isTablet: false
    },
    sidebar: {
        opened: false,
        hidden: false
    },
    effect: {
        translate3d: true
    },
    token: '',
    user: {
        id: '',
        name: ''
    },
    isAuditDetail: true
};

var mutations = (_mutations = {}, _defineProperty(_mutations, types.TOGGLE_DEVICE, function (state, device) {
    state.device.isMobile = device === 'mobile';
    state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, types.TOGGLE_SIDEBAR, function (state, opened) {
    if (state.device.isMobile) {
        state.sidebar.opened = opened;
    } else {
        state.sidebar.opened = true;
    }
}), _defineProperty(_mutations, types.SWITCH_EFFECT, function (state, effectItem) {
    for (var name in effectItem) {
        state.effect[name] = effectItem[name];
    }
}), _defineProperty(_mutations, types.SET_TOKEN, function (state, token) {
    _jsCookie2.default.set('token', token);
    state.token = token;
}), _defineProperty(_mutations, types.LOGIN_USER, function (state, user) {
    state.user = user;
}), _defineProperty(_mutations, types.IS_AUDIT_DETAIL, function (state, value) {
    state.isAuditDetail = value;
    sessionStorage.setItem('isAuditDetail', value);
}), _mutations);

exports.default = {
    state: state,
    mutations: mutations
};

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lazyLoading = __webpack_require__(81);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _Apis = __webpack_require__(80);

var _Apis2 = _interopRequireDefault(_Apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Apis from '../../../core/Apis'

exports.default = {
    path: '/label',
    component: (0, _lazyLoading2.default)('contentlabel', true),
    meta: {
        icon: 'fa fa-cog fa-fw menu-icon',
        label: '数据标注',
        expanded: false,
        noRedirect: true
    },
    children: [{
        name: 'LabelIndex',
        path: 'index',
        component: (0, _lazyLoading2.default)('contentlabel/ContentLabel'), // 加载模块
        meta: {
            label: '标注任务',
            hidden: true,
            auth: {
                needApis: [_Apis2.default.bzxt.task.missionList]
            }
        }
    }, {
        name: 'ErrorList',
        path: 'errorlist',
        component: (0, _lazyLoading2.default)('contentlabel/ErrorList'), // 加载模块
        meta: {
            label: '内容预标',
            parent: 'LabelIndex',
            nomenu: true
        }
    }, {
        name: 'Training',
        path: 'training',
        component: (0, _lazyLoading2.default)('contentlabel/Training'), // 加载模块
        meta: {
            label: '练习',
            parent: 'LabelIndex',
            nomenu: true
        }
    },
    // {
    //     // qc
    //     name: 'Inspecting',
    //     path: 'inspecting',
    //     component: lazyLoading('contentlabel/Inspecting'), // 加载模块
    //     meta: {
    //         label: '练习',
    //         parent: 'LabelIndex',
    //         nomenu: true
    //     }
    // },
    {
        name: 'Tagging',
        path: 'tagging',
        component: (0, _lazyLoading2.default)('contentlabel/Tagging'), // 加载模块
        meta: {
            label: '标注',
            parent: 'LabelIndex',
            nomenu: true
        }
    }, {
        name: 'Fault',
        path: 'fault',
        component: (0, _lazyLoading2.default)('contentlabel/Fault'), // 加载模块
        meta: {
            label: '错误数据列表',
            parent: 'LabelIndex',
            nomenu: true
        }
    }, {
        name: 'TagRecord',
        path: 'TagRecord',
        component: (0, _lazyLoading2.default)('contentlabel/TagRecord'), // 标注记录
        meta: {
            label: '标注记录',
            parent: 'LabelIndex',
            nomenu: true
        }
    }]
};

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lazyLoading = __webpack_require__(81);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _Apis = __webpack_require__(80);

var _Apis2 = _interopRequireDefault(_Apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/quality',
    component: (0, _lazyLoading2.default)('qualityManage', true),
    meta: {
        icon: 'fa fa-cog fa-fw menu-icon',
        label: '质量检查',
        expanded: false,
        noRedirect: true
    },
    children: [{
        name: 'QualityManage',
        path: 'index',
        component: (0, _lazyLoading2.default)('qualityManage/QualityManage'), // 加载模块
        meta: {
            label: '质量检查',
            hidden: true,
            auth: {
                needApis: [_Apis2.default.bzxt.quality.qualityList]
            }
        }
    }, {
        name: 'CrowdInspection',
        path: 'crowdInspection',
        component: (0, _lazyLoading2.default)('qualityManage/CrowdInspection'), // 加载模块
        meta: {
            label: '众包质检',
            hidden: true,
            auth: {
                needApis: [_Apis2.default.bzxt.quality.qualityList]
            }
        }
    }, {
        name: 'CrowdDetail',
        path: 'crowdDetail',
        component: (0, _lazyLoading2.default)('qualityManage/CrowdDetail'), // 加载模块
        meta: {
            label: '众包质检详情',
            parent: 'CrowdInspection',
            nomenu: true
        }
    }, {
        name: 'CrowdAudit',
        path: 'crowdAudit',
        component: (0, _lazyLoading2.default)('qualityManage/CrowdAudit'), // 加载模块
        meta: {
            label: '众包质检详情',
            parent: 'CrowdInspection',
            nomenu: true
        }
    }, {
        name: 'CrossFault',
        path: 'crossfault',
        component: (0, _lazyLoading2.default)('qualityManage/CrossFault'), // 加载模块
        meta: {
            label: '交叉错误数据列表',
            parent: 'QualityManage',
            nomenu: true
        }
    }, {
        name: 'QualityFault',
        path: 'qualityfault',
        component: (0, _lazyLoading2.default)('qualityManage/QualityFault'), // 加载模块
        meta: {
            label: '质检错误数据列表',
            parent: 'QualityManage',
            nomenu: true
        }
    }, {
        name: 'MissonList',
        path: 'missonlist',
        component: (0, _lazyLoading2.default)('qualityManage/TaskView'), // 加载模块
        meta: {
            label: '指定任务',
            parent: 'QualityManage',
            nomenu: true,
            api: [
                // 权限验证
                // Apis.qukan.config.list
            ]
        }
    }, {
        name: 'QcTaskDetail',
        path: 'taskdetail',
        component: (0, _lazyLoading2.default)('qualityManage/TaskDetail'), // 加载模块
        meta: {
            label: '任务详情',
            parent: 'QualityManage',
            nomenu: true,
            api: [
                // 权限验证
                // Apis.qukan.config.list
            ]
        }
    }, {
        // qc
        name: 'Inspecting',
        path: 'inspecting',
        component: (0, _lazyLoading2.default)('contentlabel/Inspecting'), // 加载模块
        meta: {
            label: '质检详情',
            parent: 'QualityManage',
            nomenu: true
        }
    }]
};

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lazyLoading = __webpack_require__(81);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _Apis = __webpack_require__(80);

var _Apis2 = _interopRequireDefault(_Apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/task',
    component: (0, _lazyLoading2.default)('taskmanage', true),
    meta: {
        icon: 'fa fa-cog fa-fw menu-icon',
        label: '任务管理',
        expanded: false,
        noRedirect: true
    },
    children: [{
        name: 'TaskList',
        path: 'index',
        component: (0, _lazyLoading2.default)('taskmanage/TaskManage'), // 加载模块
        meta: {
            label: '任务管理',
            hidden: true,
            auth: {
                needApis: [_Apis2.default.bzxt.mission.list]
            }
        }
    }, {
        name: 'TaskNew',
        path: 'new',
        component: (0, _lazyLoading2.default)('taskmanage/New'), // 加载模块
        meta: {
            label: '新建任务',
            parent: 'TaskList',
            nomenu: true
        }
    }]
};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_DEVICE = exports.TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = exports.TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = exports.EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = exports.SWITCH_EFFECT = 'SWITCH_EFFECT';

var SET_TOKEN = exports.SET_TOKEN = 'SET_TOKEN';

var TOGGLE_NO_MENU = exports.TOGGLE_NO_MENU = 'TOGGLE_NO_MENU';

var LOGIN_USER = exports.LOGIN_USER = 'LOGIN_USER';
var IS_AUDIT_DETAIL = exports.IS_AUDIT_DETAIL = 'IS_AUDIT_DETAIL';

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-12fc7a36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backTop"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-arrow-up"
    },
    on: {
      "click": _vm.backTop
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "appMain",
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), (_vm.isLogin) ? _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }) : _vm._e(), _vm._v(" "), _c('app-main', {
    class: {
      'no-login': !_vm.isLogin
    }
  }), _vm._v(" "), (_vm.isLong) ? _c('back-top') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('div', {
    staticClass: "nav-item hero-brand",
    on: {
      "click": function($event) {
        return _vm.reloadPage()
      }
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("内容标注平台")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dev.isShow),
      expression: "dev.isShow"
    }],
    staticClass: "vue branch-show"
  }, [_vm._v("\n              tagging：" + _vm._s(_vm.dev.tagging) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.user && _vm.user.id),
      expression: "!!user && user.id"
    }],
    staticClass: "nav-item"
  }, [_vm._v("\n          " + _vm._s(_vm.user.name + '（ID:' + _vm.user.id + '）') + "\n        ")]), _vm._v(" "), (!_vm.isLogin) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("登录\n        ")]) : _c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "qtt-msg-box"
  }, [_c('div', {
    staticClass: "qtt-msg-panel"
  }, [_c('header', [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.closePanel('cancel')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qtt-msg-content"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.content),
      expression: "content"
    }]
  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _c('div', {
    staticClass: "qtt-message-action"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.closePanel('sure')
      }
    }
  }, [_vm._v("确定 " + _vm._s(_vm.shortCut ? '(空格)' : ''))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.closePanel('cancel')
      }
    }
  }, [_vm._v("取消 " + _vm._s(_vm.shortCut ? 'Esc' : ''))])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.menu), function(item) {
    return (!item.meta.nomenu) ? _c('div', {
      key: item.meta.label,
      staticClass: "tile is-parent is-2"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.meta.label || item.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub-children"
    }, _vm._l((item.children), function(subItem) {
      return (!subItem.meta.nomenu) ? _c('p', {
        key: subItem.meta.label,
        staticClass: "subtitle"
      }, [_c('router-link', {
        attrs: {
          "to": item.path + '/' + subItem.path
        }
      }, [_vm._v("\n                " + _vm._s(subItem.meta.label) + "\n              ")])], 1) : _vm._e()
    }), 0)])], 1)]) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.label))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path,
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.meta.label) + "\n      ")])
  }), 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  })
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("General")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return (!item.meta.nomenu && _vm.childPerm(item.children)) ? _c('li', {
      key: index
    }, [(!item.meta.noRedirect) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }],
      style: ({
        display: _vm.isExpanded(item) ? 'block' : 'none'
      })
    }, _vm._l((item.children), function(subItem, cIndex) {
      return (!subItem.meta.nomenu) ? _c('li', {
        key: cIndex
      }, [(!subItem.meta.noRedirect) ? _c('router-link', {
        class: {
          'is-active': _vm.isSubMenu && subItem.name === _vm.selectedMenu,
        },
        attrs: {
          "to": _vm.generatePath(item, subItem),
          "id": subItem.name
        }
      }, [_vm._v("\n              " + _vm._s((subItem.meta && subItem.meta.label) || subItem.name) + "\n            ")]) : _c('a', {
        attrs: {
          "href": "javascript:;"
        }
      }, [_vm._v("\n              " + _vm._s((subItem.meta && subItem.meta.label) || subItem.name) + "\n            ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  })
},staticRenderFns: []}

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		662,
		20
	],
	"./Home.vue": [
		243
	],
	"./Login.vue": [
		663,
		19
	],
	"./Welcome.vue": [
		664,
		18
	],
	"./auth/WxLogin.vue": [
		244
	],
	"./contentlabel/AllTask.vue": [
		656,
		13
	],
	"./contentlabel/ContentLabel.vue": [
		665,
		6
	],
	"./contentlabel/Index.vue": [
		666,
		23
	],
	"./contentlabel/Inspecting.vue": [
		667,
		3
	],
	"./contentlabel/MyFollow.vue": [
		657,
		12
	],
	"./contentlabel/MyTask.vue": [
		658,
		11
	],
	"./contentlabel/TagRecord.vue": [
		668,
		17
	],
	"./contentlabel/Tagging.vue": [
		669,
		5
	],
	"./contentlabel/Training.vue": [
		670,
		4
	],
	"./qualityManage/CrowdAudit.vue": [
		671,
		9
	],
	"./qualityManage/CrowdDetail.vue": [
		672,
		8
	],
	"./qualityManage/CrowdInspection.vue": [
		673,
		16
	],
	"./qualityManage/Index.vue": [
		674,
		22
	],
	"./qualityManage/QualityManage.vue": [
		675,
		0
	],
	"./qualityManage/TaskDetail.vue": [
		676,
		2
	],
	"./qualityManage/modal/QcTaskList.vue": [
		659,
		1
	],
	"./taskmanage/DownloadList.vue": [
		660,
		15
	],
	"./taskmanage/Index.vue": [
		677,
		21
	],
	"./taskmanage/List.vue": [
		661,
		10
	],
	"./taskmanage/New.vue": [
		678,
		14
	],
	"./taskmanage/TaskManage.vue": [
		679,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 653;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseRequest2 = __webpack_require__(344);

var _BaseRequest3 = _interopRequireDefault(_BaseRequest2);

var _Apis = __webpack_require__(80);

var _Apis2 = _interopRequireDefault(_Apis);

var _Auth = __webpack_require__(76);

var _Auth2 = _interopRequireDefault(_Auth);

var _DataCenterLog = __webpack_require__(345);

var _DataCenterLog2 = _interopRequireDefault(_DataCenterLog);

var _ApiDomain = __webpack_require__(106);

var _ApiDomain2 = _interopRequireDefault(_ApiDomain);

var _Debugger = __webpack_require__(180);

var _Debugger2 = _interopRequireDefault(_Debugger);

var _qs = __webpack_require__(239);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var QuRequest = function (_BaseRequest) {
  _inherits(QuRequest, _BaseRequest);

  function QuRequest() {
    _classCallCheck(this, QuRequest);

    var _this = _possibleConstructorReturn(this, (QuRequest.__proto__ || Object.getPrototypeOf(QuRequest)).call(this));

    _this.Apis = _Apis2.default;
    _this.apiDomain = new _ApiDomain2.default();
    return _this;
  }

  _createClass(QuRequest, [{
    key: 'getUrl',
    value: function getUrl(api) {
      return this.apiDomain.getUrl(api);
    }
  }, {
    key: 'nativeSend',
    value: function nativeSend(api) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      data = Object.assign({
        token: _Auth2.default.getToken(),
        dtu: 200
      }, data);

      if (api.project === 'perm') {
        data.project = 'perm';
      }
      _Debugger2.default.save(api.url, api.type, _qs2.default.stringify(data));

      return _get(QuRequest.prototype.__proto__ || Object.getPrototypeOf(QuRequest.prototype), 'send', this).call(this, {
        url: api.url,
        type: api.type,
        timeout: api.timeout,
        headers: api.headers
      }, data).then(function (response) {
        var res = response.data;
        if (res.code == 0 || res.code == -2101 || res.code == 10017 || res.code == 10007) {
          return res;
        } else if (res.code == -126) {
          // 清除登录状态，避免登录状态失效后死循环问题
          _Auth2.default.setToken('');
          // setTimeout(() => {
          //   location.href = '/';
          // }, 2000);
          throw new Error('登陆状态失效, 请登陆');
        } else {
          // it 's joke
          var message = res.message.replace(/(周海龙|zhouhailong|曹龙龙|caolonglong|徐茹|xuru|胡配方|hupeifang)/gi, '聂元培');
          _DataCenterLog2.default.send({
            item: 2001,
            path: api.url,
            author: api.author,
            code: res.code,
            message: message
          });
          // TODO 想法：实现一个 ApiStack 类，负责在展示详细的错误日志( request, response, api, stack... )
          throw {
            message: '\u8BF7\u6C42\u5931\u8D25code: ' + res.code + ', message: ' + (message || '未知原因') + '\uFF0C\u63A5\u53E3\u5F00\u53D1\u8005\uFF1A' + api.author,
            stack: new Error().stack,
            code: res.code
          };
        }
      }, function (error) {
        var status = 0;
        if (error.response) {
          status = error.response.status;
        } else if (error.request) {
          status = error.request.status;
        }
        throw new Error('\u7F51\u7EDC\u9519\u8BEF[' + status + '](' + api.url + '):' + error.message);
      });
    }
  }, {
    key: 'send',
    value: function send(api) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var url = this.apiDomain.getUrl(api);
      return this.nativeSend({
        url: url,
        type: api.type,
        timeout: api.timeout,
        headers: api.headers,
        author: api._author || '',
        project: data.project || api.project
      }, data);
    }
  }, {
    key: 'export',
    value: function _export(api) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      data = Object.assign({
        token: _Auth2.default.getToken(),
        dtu: 200
      }, data);
      var params = _qs2.default.stringify(data);
      var url = this.apiDomain.getUrl(api);
      url = url + '?' + params;
      window.open(url, '_blank');
    }
  }, {
    key: 'jsonp',
    value: function jsonp(url) {
      if (!url) {
        return;
      }
      return new Promise(function (resolve, reject) {
        window.cb = function (result) {
          resolve(result);
        };
        var JSONP = document.createElement('script');
        JSONP.type = 'text/javascript';
        JSONP.src = '' + url;
        JSONP.onerror = function () {
          reject();
        };
        document.getElementsByTagName('head')[0].appendChild(JSONP);
        setTimeout(function () {
          document.getElementsByTagName('head')[0].removeChild(JSONP);
        }, 500);
      });
    }
  }, {
    key: 'getBranch',
    value: function getBranch() {
      return this.apiDomain.getBranchMap();
    }
  }, {
    key: 'isProduct',
    value: function isProduct() {
      return this.apiDomain.isProduct();
    }
  }]);

  return QuRequest;
}(_BaseRequest3.default);

exports.default = QuRequest;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(75);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TOKEN_KEY = 'token';

var Auth = function () {
    function Auth() {
        _classCallCheck(this, Auth);
    }

    _createClass(Auth, null, [{
        key: 'getToken',
        value: function getToken() {
            return _jsCookie2.default.get(TOKEN_KEY);
        }
    }, {
        key: 'setToken',
        value: function setToken(v) {
            // cookie保存7天
            return _jsCookie2.default.set(TOKEN_KEY, v, {
                expires: 7
            });
        }
    }, {
        key: 'delToken',
        value: function delToken() {
            _jsCookie2.default.remove(TOKEN_KEY);
        }
    }]);

    return Auth;
}();

exports.default = Auth;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiInfo = function () {
    function ApiInfo(_ref) {
        var path = _ref.path,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'get' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            _ref$headers = _ref.headers,
            headers = _ref$headers === undefined ? {} : _ref$headers,
            _ref$project = _ref.project,
            project = _ref$project === undefined ? 'qupost' : _ref$project,
            _ref$author = _ref.author,
            author = _ref$author === undefined ? '未定义' : _ref$author;

        _classCallCheck(this, ApiInfo);

        this._path = path;
        this._type = type;
        this._author = author;
        this.timeout = timeout;
        this.headers = headers;
        this.project = project;
    }

    _createClass(ApiInfo, [{
        key: 'path',
        get: function get() {
            return this._path;
        }
    }, {
        key: 'type',
        get: function get() {
            return this._type;
        }
    }, {
        key: 'author',
        get: function get() {
            return this._author;
        }
    }]);

    return ApiInfo;
}();

exports.default = ApiInfo;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Perm = __webpack_require__(341);

var _Perm2 = _interopRequireDefault(_Perm);

var _Tagging = __webpack_require__(343);

var _Tagging2 = _interopRequireDefault(_Tagging);

var _Crowd = __webpack_require__(340);

var _Crowd2 = _interopRequireDefault(_Crowd);

var _Search = __webpack_require__(342);

var _Search2 = _interopRequireDefault(_Search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    perm: _Perm2.default,
    crowd: _Crowd2.default,
    bzxt: _Tagging2.default,
    search: _Search2.default
};

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
exports.default = function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(653)("./" + name + (index ? '/Index' : '') + '.vue');
  };
};

/***/ })

},[346]);


// WEBPACK FOOTER //
// static/js/app.25123b92a75b823ab1a0.js